import { BaseSchema } from "./BaseSchema";
import { BaseTypeSchema } from "./BaseTypeSchema";

export class BaseVariableSchema extends BaseSchema
{
    name: string;
    type: BaseTypeSchema;
    defaultValue: string;
    constructor(name: string, type: BaseTypeSchema, defaultValue?: string)
    {
        super();
        this.name = name;
        this.type = type;
        this.defaultValue = defaultValue ?? "";
    }
}